module.exports = __webpack_public_path__ + "img/juhua.28a46a24.png";